<!-- ========================================================================================
      Author: Alizadeh
========================================================================================== -->

<!-- <template src="./Bills.html">-->
<template>
  <div>
    <vx-card :title="title">
      <div class="vx-row mb-2">
        <div class="vx-col w-full">
          <vs-button
            class="mr-3 mb-2"
            @click="$router.back()"
            type="flat"
            icon-pack="feather"
            icon="icon-chevron-right"
          >بازگشت</vs-button>
        </div>
      </div>
      <div class="vx-row">
        <div
          class="vx-col w-1/3"
          v-for="(item, index) of gateways"
          :key="index"
          @dblclick="(e)=>{copyId(e,item)}"
        >
          <vx-card class="mb-2 w-full">
            <p>نام فروشگاه:</p>
            <h5>
              <span style="vertical-align: middle" v-if="item.merchantType">
                <feather-icon
                  :title="DraftType[item.merchantType].title"
                  :icon="DraftType[item.merchantType].icon"
                  :svgClasses="[`h-5 w-6 stroke-current `]"
                ></feather-icon> </span
              >{{ item.shopName }}
            </h5>
            <p class="mt-3">وبسایت:</p>
            <h5>{{ item.websiteAddress }}</h5>
            <p class="mt-3">تاریخ ایجاد درگاه:</p>
            <h5>
              {{ $moment(item.creationTime).format("HH:mm:ss jYYYY/jM/jD") }}
            </h5>
            <vs-button
              @click="show_GenerateApiKey(item.shopId, item.shopName)"
              class="mt-3"
              color="success"
              type="border"
              icon-pack="feather"
              >دریافت کد جدید</vs-button
            >
          </vx-card>
        </div>
      </div>
    </vx-card>
    <gateway-requests />
    <generate-api-key ref="GenerateApiKey1" />
  </div>
</template>
<style lang="scss">
</style>
<script>
import GatewayRequests from "../draft/GatewayRequests.vue";
import GenerateApiKey from "./GenerateApiKey";
import { DraftType } from "@/enums.js";
export default {
  props: {},
  components: {
    GatewayRequests,
    GenerateApiKey,
  },
  data() {
    return {
      gateways: [],
      DraftType,
    };
  },
  computed: {
    title() {
      return this.$route.query.mid
        ? `درگاهای فعال "${this.$route.query.fullName}"`
        : "درگاهای فعال";
    },
  },
  methods: {
    getData() {
      let payload = {
        params: {
          MaxResultCount: 999,
          SkipCount: 0,
        },
      };
      let loading = this.$vs.loading();
      let path = "";
      if (this.$route.query.mid) {
        path = "/api/services/app/Gateway/GetGateways";
        payload.params.merchantId = this.$route.query.mid;
      } else {
        path = "/api/services/app/Gateway/GetGateways_CurrentUser";
      }
      this.$http
        .get(path, payload)
        .then((response) => {
          this.gateways = response.data.result.items;
          //this.totalCount = response.data.result.totalCount;
          this.$vs.loading.close();
        }) //end success
        .catch((error) => {
          console.log(error);
          this.$vs.loading.close();
        }); //end http
    },
    show_GenerateApiKey(shopId, shopName) {
      this.$refs.GenerateApiKey1.show(shopId, shopName,!this.$route.query.mid);
    },
    copyId(e,item) {
      if (e.ctrlKey) {
        this.$helper.copy(JSON.stringify(item, null, 4), "ID کپی شد");
      } else {
        this.$helper.copy(item.shopId, "ID کپی شد");
      }
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
